var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('card',{attrs:{"type":"plain"}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Google Maps")])]),_c('div',{staticClass:"map",attrs:{"id":"map"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }